import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { loginRequest } from "../functions/api_calls";
import { AppContext } from "../../../context/context";
import { setToken, resolveRoleFromDecoded } from '../functions/authentication_management';
import { DecodedAuthToken } from "../types/AuthTypes";
import { jwtDecode } from "jwt-decode";

export default function useLoginHandler() {
  const { t } = useTranslation('auth');
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useLoginHandler must be used within the app provider");
  }

  const { userData } = context;
  const { setUserDetails } = userData;

  const handleLogin = async (username: string, password: string) => {
    const results = await loginRequest(username, password);

    if (results.auth_token === '') {
      console.log("No token found?");
      throw new Error(t('loginModal.noTokenError'));
    }

    setToken(results.auth_token);
    const decodedToken = jwtDecode<DecodedAuthToken>(results.auth_token);
    const userId = decodedToken.user_id;

    setUserDetails({
      email: username,
      fullName: '',
      userId,
      role: resolveRoleFromDecoded(decodedToken),
      customerId: decodedToken.customer_id ?? null,
      customerName: decodedToken.customer_name ?? null,
      companyRole: decodedToken.company_role ?? null,
    });
  };

  return handleLogin;
}
